import { Fragment, useCallback, useState } from 'react';
import BasicButton from '../../components/BasicButton';
import BasicInput from '../../components/BasicInput';
import PageCenterContainer from '../../components/PageCenterContainer';
import PageHeader from '../../components/PageHeader';
import { sendUserMessage } from '../../misc/lib/contact';
import './ContactPage.scss';

const ContactPage = () => {
  const [ name, setName ] = useState('');
  const [ email, setEmail ] = useState('');
  const [ messageSubject, setMessageSubject ] = useState('');
  const [ messageBody, setMessageBody ] = useState('');
  const [ sending, setSending ] = useState(false);
  const [ error, setError ] = useState<'name' | 'email' | 'subject' | 'body'>();

  const doSendMessage = useCallback(() => {
    if (!name) { setError('name'); return; }
    if (!email) { setError('name'); return; }
    if (!messageSubject) { setError('subject'); return; }
    if (!messageBody) { setError('body'); return; }

    setSending(true);
    sendUserMessage({
      author: {
        email: email, name: name
      },
      message: {
        body: messageBody, subject: messageSubject
      }
    }).then((id) => {
      console.log(`Message sent with ID: ${ id }`);
    }).catch((err) => {
      console.error(err);
      if (err.message === 'invalid-email') setError('email');
    }).finally(() => {
      setSending(false);
    });
  }, [ name, email, messageSubject, messageBody ]);

  return (
    <PageCenterContainer>
      <Fragment>
        <PageHeader text="Kapcsolat" />
        <div className="contactpage-container">
          <div className="contactpage-message-form">
            <h2>Lépj kapcsolatba a Báthory István DSE-vel!</h2>
            <BasicInput placeholder="Az Ön neve" text={ name }
              onTextChanged={ setName } error={ error === 'name' } />
            <BasicInput placeholder="Az Ön e-mail címe" text={ email }
              onTextChanged={ setEmail } error={ error === 'email' } />
            <BasicInput placeholder="Az üzenete tárgya" text={ messageSubject }
              onTextChanged={ setMessageSubject } error={ error === 'subject' } />
            <BasicInput placeholder="Az üzenet szövege..." text={ messageBody }
              onTextChanged={ setMessageBody } error={ error === 'body' } />
            <BasicButton text="Üzenet elküldése" type="primary"
              onClick={ doSendMessage } working={ sending } disabled={ sending } />
          </div>
          <div className="contactpage-other-contact">
            <h2>Egyesület elnöke</h2>
            <div>
              <h3>Csapos Zsolt</h3>
              <p>
                Telefonszám: <b><a href="tel:+36703793268">+36 70 379 3268</a></b><br />
                E-mail: <b><a href="mailto:bathorydse@gmail.com">bathorydse@gmail.com</a></b>
              </p>
            </div>
          </div>
        </div>
      </Fragment>
    </PageCenterContainer>
  );
};

export default ContactPage;
